/* ==========================================================================
   CURELIX LISTICLE — mobile sticky CTA behavior
   - The bar is shown only on mobile (CSS hides it on larger screens).
   - It appears once the reader scrolls into the start anchor (Reason 3).
   - It hides while any CTA card marked [data-cxl-cta] is on screen.
   - It stays hidden after the final CTA is reached, so it never covers the
     final guarantee, shipping line or footer.
   ========================================================================== */
(function () {
  function init() {
    var bar = document.querySelector('[data-cxl-sticky]');
    if (!bar) return;

    var link = bar.querySelector('a');
    var start = document.getElementById(bar.getAttribute('data-start') || 'reason-3');
    var ctas = Array.prototype.slice.call(document.querySelectorAll('[data-cxl-cta]'));
    var finalCta = ctas.length ? ctas[ctas.length - 1] : null;
    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var started = start ? start.getBoundingClientRect().top < vh * 0.6 : window.scrollY > 800;
      var ctaOnScreen = ctas.some(function (el) {
        var r = el.getBoundingClientRect();
        return r.top < vh && r.bottom > 0;
      });
      var reachedFinal = finalCta ? finalCta.getBoundingClientRect().top < vh : false;
      var show = started && !ctaOnScreen && !reachedFinal;

      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.setAttribute('tabindex', show ? '0' : '-1');
    }

    // The check is light (three getBoundingClientRect calls), so it runs directly on scroll.
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
